import { api } from '#/apis';


export const clearCompactCache = async (entrata_report_name, property_id) => {

    const { data } = await api.post(`/reports-compact-cache/${entrata_report_name}/${property_id}`);

    return data;
};
